module.exports = __webpack_public_path__ + "img/xun_card1.f18f93f4.png";